import { useMemo } from 'react';

import { VariantRuleStylesheet } from '@candu-ai/styleguide/types';

export interface VariantItem {
  value: string;
  tagName?: string;
  isHidden?: boolean;
  name: string;
  conditions:
    | { variant: string; variation?: string; color?: never; outline?: never }
    | {
        variant: string;
        variation?: never;
        color: string;
        outline?: string;
      };
}

/**
 * Maps variants into an array with key properties
 * Fixes typography mappings
 */
export const usePreparedVariants = (
  componentName?: string,
  variants?: VariantRuleStylesheet,
): VariantItem[] => {
  return useMemo(() => {
    if (!componentName || !variants) {
      return [];
    }

    const componentRealName = Object.entries(variants || {}).find(
      ([name]) => name?.toLowerCase() === componentName.toLowerCase(),
    );
    const componentVariants = Object.entries(variants[componentRealName?.[0] || 0] || {});

    return componentVariants.map(
      ([key, value]) =>
        ({
          value: key,
          name: value.name,
          isHidden: value.isHidden,
          conditions:
            value.tagName || componentName?.toLowerCase() === 'typography'
              ? {
                  variant: value.tagName?.toUpperCase() || 'P',
                  variation: key,
                }
              : {
                  variant: key,
                },
        } as VariantItem),
    );
  }, [componentName, variants]);
};
